import React from 'react';
import { Route } from 'react-router';
import { Tabs, Tab, IconButton, SvgIcon, ClickAwayListener, Tooltip } from '@material-ui/core';
import { Theme, createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Remove';
import { mdiPin, mdiPinOff } from '@mdi/js';

import { __ } from '../../utils/intl';
import { TreeItem } from '../../types/tree';
import { DossierData } from '../../types/dossier';
import { RootState } from '../../store/reducers';
import { SinglePanelStatus, RightPanelType } from '../../store/ui/reducers';
import Sidebar, { Props as SidebarProps } from '../Common/Sidebar';
import InspectorPanel from './InspectorPanel';
import VersionsPanel from './VersionsPanel';
import SimpleSvgIcon from '../Common/SimpleSvgIcon';

const styles = (theme: Theme) => createStyles({
  root: {
    
  },
  header: {
    display: 'flex',
    backgroundColor: '#e0e0e0',
    flexDirection: 'row-reverse',
  },
  tabs: {
    flexGrow: 1,
  },
  topActions: {
    padding: theme.spacing(1),
    flexShrink: 0,
  },
  tabsFlexContainer: {
    justifyContent: 'flex-end',
  },
  tab: {
    minWidth: 60,
  },
  tabContent: {
    flexGrow: 1,
    overflow: 'auto',
  },
});

interface OwnProps {
  status: SinglePanelStatus<RightPanelType>;
  dossier: DossierData;
  onPin: () => void;
  onChange: (key: RightPanelType) => void;
  onClose: () => void;
  selectedItem: TreeItem | null;
  onSelect: (item: TreeItem) => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

interface State {

}

class RightPanel extends React.Component<Props, State> {

  renderContent() {
    const {
      status,
    } = this.props; 
    switch (status.key) {
      case 'inspector': {
        return (
          <Route component={InspectorPanel} />
        );
      }
      case 'versions': {
        return (
          <Route path="/dossier/:dossierId/:viewMode" component={VersionsPanel} />
        );
      }
      default:
        return null;
    }
  }

  handleClickAway() {
    const { status, onClose } = this.props;
    if (status.open && !status.pinned) {
      onClose();
    }
  }

  render() {
    const {
      classes,
      status,
      onPin,
      onClose,
      onChange,
      onWidthChange,
    } = this.props;
    return (
      <>
        <header className={classes.header}>
          <Tabs
            className={classes.tabs}
            variant="scrollable"
            scrollButtons="auto"
            value={status.key}
            onChange={(event, key) => onChange(key)}
            indicatorColor="primary"
            textColor="primary"
            classes={{
              flexContainer: classes.tabsFlexContainer
            }}
          >
            <Tab className={classes.tab} label={__('panels.inspector.title')} value="inspector" />
            <Tab className={classes.tab} label={__('panels.versions.title')} value="versions" />
          </Tabs>
          <div className={classes.topActions}>
            <Tooltip title={__('panels.close')}>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={__('panels.pin')}>
              <IconButton size="small" onClick={onPin}>
                <SimpleSvgIcon path={status.pinned ? mdiPin : mdiPinOff} />
              </IconButton>
            </Tooltip>
          </div>
        </header>
        <div className={classes.tabContent}>
          {this.renderContent()}
        </div>
      </>
    )
  }
}

export default withStyles(styles)(RightPanel);
